import { ReactElement, memo } from 'react';
import { formatTranslation, inspectionStatusLabelKey } from 'intl';
import { Box } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { useIntl } from 'react-intl';
import { InspectionStatusProps, InspectionStatusSize } from './types';
import { statusColors, sizeStyles, baseContainerSx } from './styles';
import { ELLIPSIS_TEXT_SX } from 'components/common/dataGrid/styles';

const InspectionStatus = ({
  status,
  size = InspectionStatusSize.small,
}: InspectionStatusProps): ReactElement => {
  const intl = useIntl();

  return (
    <Box
      sx={mergeSx(
        baseContainerSx,
        size === InspectionStatusSize.table ? ELLIPSIS_TEXT_SX : undefined,
        {
          color: statusColors[status],
          ...sizeStyles[size],
        }
      )}
    >
      {formatTranslation(intl, inspectionStatusLabelKey(status))}
    </Box>
  );
};

export const MemoInspectionStatus = memo(InspectionStatus);
